export default __webpack_public_path__ + "static/media/7.384f1c46.jpg";